var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasAccept && _vm.message_uuid && _vm.loaded
    ? _c("section", [
        _c("hr", { staticClass: "pb-0 mb-2 mt-2" }),
        !_vm.meeting_accepted && !_vm.meeting_declined
          ? _c(
              "span",
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn-fill",
                    attrs: { variant: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.DecideMeeting(true)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("MEETING_ACCEPT")) + "\n    "
                    ),
                  ]
                ),
                _c(
                  "b-button",
                  {
                    staticClass: "btn-fill",
                    attrs: { variant: "danger" },
                    on: {
                      click: function ($event) {
                        return _vm.DecideMeeting(false)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("MEETING_DECLINE")) + "\n    "
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.meeting_accepted
          ? _c("span", [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("YOU_HAVE_ACCEPTED_MEETING")) +
                  " " +
                  _vm._s(_vm.FormatDateTime(_vm.meeting_accept_date)) +
                  "\n  "
              ),
            ])
          : _vm._e(),
        _vm.meeting_declined
          ? _c("span", [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("YOU_HAVE_DECLINED_MEETING")) +
                  " " +
                  _vm._s(_vm.FormatDateTime(_vm.meeting_accept_date)) +
                  "\n  "
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }